'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objAsArray = require('shared/utils/objAsArray');

var _objAsArray2 = _interopRequireDefault(_objAsArray);

var _getAllMatchingJobs = require('shared/utils/getAllMatchingJobs');

var _getAllMatchingJobs2 = _interopRequireDefault(_getAllMatchingJobs);

var _constants = require('shared/utils/match/constants');

var _constants2 = _interopRequireDefault(_constants);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import arrayAsObj from 'shared/utils/arrayAsObj';
var getCurrentPage = function getCurrentPage(route, _ref) {
  var jobPages = _ref.jobPages;

  if (jobPages[route]) {
    return jobPages[route];
  }

  return {};
};

// returns the currently selected tab. If no
// tab is selected, return the default tab.
var getCurrentTab = function getCurrentTab(route, _ref2) {
  var jobPages = _ref2.jobPages;

  if (jobPages[route]) {
    return jobPages[route].currentTab;
  }

  return 'skills';
};

//const supplementObj = (obj, fn) => {
//return arrayAsObj(objAsArray(obj, fn));
//};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref3, _ref4) {
  var user = _ref3.user,
      jobMatch = _ref3.ui.jobMatch,
      _ref3$data = _ref3.data,
      interests = _ref3$data.interests,
      skills = _ref3$data.skills,
      educationLevels = _ref3$data.educationLevels,
      jobs = _ref3$data.jobs;
  var route = _ref4.route;

  var job = jobs[route.split('/').pop()];
  if (!job) {
    throw new Error('Job not found');
  }

  var jobInterests = (0, _objAsArray2.default)(job.interests).map(function (_ref5) {
    var id = _ref5.id,
        value = _ref5.value;
    return {
      id: id,
      label: interests[id].label || '',
      icon: interests[id].image || {},
      values: [{
        id: 'user',
        label: 'you',
        value: user.interests[id] !== undefined ? user.interests[id] : _constants2.default.INTERESTS.DEFAULT
      }, {
        id: 'job',
        label: 'job',
        value: parseFloat(value) || 0.0
      }]
    };
  });

  var jobSkills = (0, _objAsArray2.default)(job.skills).map(function (_ref6) {
    var id = _ref6.id;

    return {
      id: id,
      label: skills[id].label || '',
      selected: user.skills.indexOf(id) !== -1
    };
  });

  var requiredEducation = (0, _extends3.default)({}, educationLevels[job.education.required]);

  var matches = (0, _getAllMatchingJobs2.default)({
    user: user,
    data: {
      jobs: jobs,
      skills: skills,
      interests: interests,
      educationLevels: educationLevels
    }
  }, [job])[0].matches;


  return {
    job: job,
    tabs: jobMatch.tabs.map(function (tab) {
      var match = 0;
      if (tab.id === 'education') {
        match = matches.education / 100;
      } else if (tab.id === 'interests') {
        match = matches.interest;
      } else {
        match = matches.skills;
      }
      if (match > 1) {
        match = 1;
      } else if (match < 0) {
        match = 0;
      }
      return (0, _extends3.default)({}, tab, {
        match: match
      });
    }),
    currentTab: getCurrentTab(route, jobMatch),
    showMore: getCurrentPage(route, jobMatch).showMore || false,

    interests: jobInterests,
    skills: jobSkills,
    education: {
      image: {},
      levels: (0, _objAsArray2.default)(educationLevels),
      user: user.education,
      preferred: job.education.preferred,
      required: requiredEducation
    }
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, _ref7) {
  var route = _ref7.route;

  return {
    changeTab: function changeTab(id) {
      return dispatch((0, _actions.changeTab)(route, id));
    },
    showMoreInterests: function showMoreInterests() {
      return dispatch((0, _actions.showMoreInterests)(route));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobMatch/selectors.js
// module id = 1206
// module chunks = 0